import { LitElement } from "lit";
import { Selector, SelectorEventDetail } from "../rules";

export abstract class OutDesignSelectorEventDispatcherElement extends LitElement {
    emit(part: Array<Partial<Selector>>, mode: string) {
        this.dispatchEvent(new CustomEvent("selector-added", {
            detail: { part: part, mode: mode } as SelectorEventDetail,
            bubbles: true,
            composed: true
        }));
    }

    emitTemp(part: Array<Partial<Selector>>, mode: string) {
        this.dispatchEvent(new CustomEvent("temp-selector-added", {
            detail: { part: part, mode: mode } as SelectorEventDetail,
            bubbles: true,
            composed: true
        }));
    }
}